export enum ComponentColumnSortingDirection {
    ASC = 'asc',
    DESC = 'desc',
}

export enum NonStatusFilter {
    NEAR_EXPIRATION = 'Near Expiration',
    READY_TO_FUND = 'Ready To Fund',
}

export enum ApplicationType {
    INDIVIDUAL = 'I',
    JOINT = 'J',
}
